import { Typography, Box, Grid, RadioGroup, FormControlLabel, Radio, FormControl, Select, MenuItem, FormHelperText } from '@material-ui/core';
import { MobileRegularPage } from '../../../components';
import { reproductiveLifeJourneyPositions } from "../../../data/db";
import styles from './Demographic.style';
import { RepLIProviderTextField } from '../../../components';


const Demographics = props => {
    const classes = styles();

    return (
        <MobileRegularPage>
            <Grid container>
                <Grid item xs={12} md={12}>

                    <Box  >
                        <Typography margin="dense" variant="h5" >
                            Where are you on your reproductive life journey ?*
                        </Typography>
                        <FormControl
                            variant="outlined"
                            component="fieldset"
                            error={props.submitted && !props.validator.fieldValid('reproductive_life_journey')}
                            fullWidth>
                            <Select value={props.rljPosition} onChange={props.onRLJPositionChange}>
                                {reproductiveLifeJourneyPositions.map(option =>
                                    <MenuItem key={option} value={option}>{option}</MenuItem>
                                )}
                            </Select>
                            <FormHelperText>
                                {props.validator.message('reproductive_life_journey', props.rljPosition, 'required')}
                            </FormHelperText>
                        </FormControl>
                    </Box>


                    <Box className={classes.inputSection}>
                        <Typography variant="h5" >Are you satisfied with your reproductive life journey at this time ?*
                        </Typography>
                        <FormControl
                            component="fieldset"
                            error={props.submitted && !props.validator.fieldValid('satisfied_Response')}
                        >
                            <RadioGroup row
                                value={props.satisfiedRespWithRLJ}
                                onChange={props.onSatisfiedRespWithRLJChange}>
                                <FormControlLabel control={<Radio color="primary" />} value="yes" label="Yes" />
                                <FormControlLabel control={<Radio color="primary" />} value="no" label="No" />
                            </RadioGroup>
                            <FormHelperText error style={{ textAlign: "center" }}>
                                {props.validator.message('satisfied_Response', props.satisfiedRespWithRLJ, 'required')}
                            </FormHelperText>
                        </FormControl>
                    </Box>

                    {props.satisfiedRespWithRLJ &&
                        <Box xs={10} md={10}>
                            <Typography variant="h5" >
                                Would you please share why you are or are not satisfied with your reproductive life journey ?*
                            </Typography>
                            <RepLIProviderTextField
                                value={props.satisfiedReasonWithRLJ}
                                onChange={e => props.onSatisfiedReasonWithRLJChange(e, "Satisfied Reason With RLJ")}
                                inputProps={{ maxLength: 2500 }}
                                autoFocus
                                error={props.submitted && !props.validator.fieldValid('satisfied_Reason')}
                                helperText={props.validator.message('satisfied_Reason', props.satisfiedReasonWithRLJ, 'required')}
                            />
                        </Box>
                    }


                    <Box className={classes.inputSection}>
                        <Typography variant="h5" >
                            Have there been times that you were not satisfied with your reproductive life journey ?*
                        </Typography>
                        <FormControl
                            component="fieldset"
                            error={props.submitted && !props.validator.fieldValid('not_satisfied_response')}
                        >
                            <RadioGroup row
                                value={props.notSatisfiedRespWithRLJ}
                                onChange={props.onNotSatisfiedRespWithRLJChange}>
                                <FormControlLabel value="yes" control={<Radio color="primary" />} label="Yes" />
                                <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
                            </RadioGroup>
                            <FormHelperText error style={{ textAlign: "center" }}>
                                {props.validator.message('not_satisfied_response', props.notSatisfiedRespWithRLJ, 'required')}
                            </FormHelperText>
                        </FormControl>
                    </Box>
                    {props.notSatisfiedRespWithRLJ &&
                        <Box item xs={10} md={10}>
                            <Typography variant="h5" >
                                Would you please share when you were not satisfied with your reproductive life journey ?*
                            </Typography>
                            <RepLIProviderTextField
                                value={props.notSatisfiedReasonWithRLJ}
                                onChange={e => props.onNotSatisfiedReasonWithRLJChange(e, "Not Satisfied Reason With RLJ")}
                                inputProps={{ maxLength: 2500 }}
                                autoFocus
                                error={props.submitted && !props.validator.fieldValid('not_Satisfied_Reason')}
                                helperText={props.validator.message('not_Satisfied_Reason', props.notSatisfiedReasonWithRLJ, 'required')}
                            />
                        </Box>
                    }
                </Grid>
            </Grid>
        </MobileRegularPage>


    )
}

export default Demographics